import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { RR_FILTER_TYPE } from '../../../common/enum/filters/filter-type.enum';
import { RRFilterContainerModel } from '../../../common/interfaces/filters/filter-container.interface';
import { RRIFilterOption } from '../../../common/interfaces/filters/filter-options.interface';
import { RRIFilterOutput } from '../../../common/interfaces/filters/filter-output.interface';
import { RRIFilter } from '../../../common/interfaces/filters/filter.interface';
import { RRFilterOption } from '../../../common/types/filter-option.type';
import {
  RRICheckboxOption,
  RRIDropdownOptionTemplate,
  RRIInput,
  RRIInputOption,
} from '../../../form-inputs/public-api';
import { RRITag } from '../../../tags/public-api';
import { RRITagValueFilter } from '../../public-api';

@Component({
  selector: 'rr-table-filters-container',
  templateUrl: './table-filters-container.component.html',
  styleUrls: ['./table-filters-container.component.scss'],
})
export class TableFiltersContainerComponent<T> implements OnInit {
  public showMetaButtons = false;
  public showEndButtons = false;
  public addTemplateMeta: TemplateRef<any>;
  public addTemplateEnd: TemplateRef<any>;
  public disableSubmitButton = false;
  public FilterType = RR_FILTER_TYPE;
  public resetTagsFilter: boolean;
  @Input() filterContainerModel: RRFilterContainerModel<T>;
  @Output() changedFilter: EventEmitter<RRIFilterOutput<any>[]> =
    new EventEmitter();
  // TODO
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() submit: EventEmitter<boolean> = new EventEmitter();
  // TODO
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() reset: EventEmitter<boolean> = new EventEmitter();
  @Output() resetFilterClicked: EventEmitter<RRIFilter<RRIFilterOption<T>, T>> =
    new EventEmitter();

  @Output() dropdownFilterClicked: EventEmitter<RRIFilterOutput<any>> =
    new EventEmitter();
  constructor() {
    this.resetTagsFilter = false;
  }

  ngOnInit(): void {
    if (this.filterContainerModel == null) {
      this.filterContainerModel = {
        hideContainer: true,
      } as RRFilterContainerModel<any>;
    }

    if (this.filterContainerModel.activateSubmitButton == null) {
      this.filterContainerModel.activateSubmitButton = false;
    }

    if (this.filterContainerModel.activateResetButton == null) {
      this.filterContainerModel.activateResetButton = true;
    }
  }

  public getTextFilter(
    filter: RRIFilter<T, RRFilterOption<T>>,
  ): RRIFilter<string, string> {
    return filter as any;
  }

  public getDateFilter(
    filter: RRIFilter<T, RRFilterOption<T>>,
  ): RRIFilter<number[], number[]> {
    return filter as any;
  }

  public getSingleOptionFilter(
    filter: RRIFilter<T, RRFilterOption<T>>,
  ): RRIFilter<RRIFilterOption<T>, T> {
    return filter as any;
  }

  public getMultipleOptionsFilter(
    filter: RRIFilter<T, RRFilterOption<T>>,
  ): RRIFilter<RRIFilterOption<T>[], T> {
    return filter as any;
  }

  public getTagsFilter(
    filter: RRIFilter<T, RRFilterOption<T>>,
  ): RRIFilter<RRITagValueFilter[], RRITag> {
    return filter as any;
  }

  public getTags(
    tags: RRIFilterOption<RRFilterOption<T>>[],
  ): RRIFilterOption<RRITag>[] {
    return tags as any;
  }

  public getSingleOptionFormSettings(
    formSettings: RRIInput<RRIInputOption<T> | RRIInputOption<T>[]>,
  ): RRIInput<RRIInputOption<T>> {
    return formSettings as any;
  }

  public getMultipleOptionsFormSettings(
    formSettings: RRIInput<RRIInputOption<T> | RRIInputOption<T>[]>,
  ): RRIInput<RRIInputOption<T>[]> {
    return formSettings as any;
  }

  public getCheckboxOptionsFormSettings(
    formSettings: RRIInput<RRIInputOption<T> | RRIInputOption<T>[]>,
  ): RRIInput<RRICheckboxOption<T>[]> {
    return formSettings as any;
  }

  public getDropdownOptionsTemplate(
    optionsTemplate: TemplateRef<RRIDropdownOptionTemplate<T>>,
  ): TemplateRef<RRIDropdownOptionTemplate<string>> {
    return optionsTemplate as any;
  }

  public onFilterChange(event: RRIFilterOutput<any>): void {
    const filters = this.filterContainerModel.filters.map((filter) => {
      if (filter.filterBy.fieldName === event.filterBy.fieldName) {
        filter.filterBy.value = event.filterBy.value;
      }

      return { type: filter.type, filterBy: filter.filterBy };
    });

    this.changedFilter.emit(filters);
  }

  public resetFilters(): void {
    const defaultFilters = this.getDefaultValues();
    this.resetTagsFilter = true;

    if (!this.disableSubmitButton) {
      this.changedFilter.emit(defaultFilters);
    }

    this.reset.emit(true);
  }

  public onTagsFilterWasReseted(): void {
    this.resetTagsFilter = false;
  }

  public submitFilters(): void {
    if (!this.areInvalidFilters() && !this.disableSubmitButton) {
      this.submit.emit(true);
    } else {
      this.submit.emit(false);
    }
  }

  public onDropdownFilterClicked(event: RRIFilterOutput<any>) {
    this.dropdownFilterClicked.emit(event);
  }

  public onCleanFilterClicked(event: any): void {
    this.resetFilterClicked.emit(event);
  }

  private getDefaultValues(): RRIFilterOutput<any>[] {
    return this.filterContainerModel.filters.map(
      (filter: RRIFilter<T, RRFilterOption<T>>) => {
        return {
          type: filter.type,
          filterBy: {
            ...filter.filterBy,
            value: filter.filterBy.defaultValue,
          },
        };
      },
    );
  }

  private areInvalidFilters(): boolean {
    return this.filterContainerModel.filters.some(
      (filter) => filter.settings.invalid,
    );
  }
}
